import { Box } from '@chakra-ui/react';
import { Form, FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import PreviewImage from 'UiKit/preview-image';

import usePostCreateGiveaway from 'Domain/brief-live/usePostCreateGiveaway';
import useGetGiveawayById from 'Domain/brief-live/useGetGiveawayById';
import BriefGiveawayFormProvider, { useBriefGiveawayFormState } from 'View/brief-live/state/giveaway-form';
import Head from 'View/brief-live/section/giveaway-form/head';
import InsertGiveaway from 'View/brief-live/section/giveaway-form/insert-giveaway';
import UpdateGiveaway from 'View/brief-live/section/giveaway-form/update-giveaway';

import { InitialValuesCreate, GIVEAWAY_FORM_DRAFT_KEY } from './const';

import styles from './styles.module.css';

const GiveawayForm = () => {
  const { t } = useTranslation('desktop-brief-live');
  const { id } = useParams();
  const defaultValues = !id ? InitialValuesCreate : InitialValuesCreate;
  const form = useForm({ defaultValues, mode: 'onChange' });
  const { state, updateState } = useBriefGiveawayFormState();
  const { selectedImagePreview, isOpenImagePreview } = state;

  const { data: giveawayData } = useGetGiveawayById(id);

  const { mutate: createGiveaway } = usePostCreateGiveaway({
    onSuccess: () => sessionStorage.removeItem(GIVEAWAY_FORM_DRAFT_KEY),
  });

  const handleSubmit = (formValues) => {
    if (!id) {
      createGiveaway(formValues);
    }
  };

  const handleClosePreview = () => {
    updateState({
      isOpenImagePreview: false,
      selectedImagePreview: [],
    });
  };

  const watchedGiveaways = form.watch('giveaways') || [];
  const isAnyProductEditing = watchedGiveaways.some((g) => g?.rules?.requiredProducts?.some((p) => p?.isEdit));

  return (
    <Box className={styles['form__container']}>
      <FormProvider {...form}>
        <Form control={form.control} onSubmit={({ data }) => handleSubmit(data)}>
          <Head id={id} t={t} form={form} isValid={form.formState.isValid && !isAnyProductEditing} />
          <Condition statement={!id} children={<InsertGiveaway form={form} />} fallback={<UpdateGiveaway giveawayData={giveawayData} />} />
        </Form>
      </FormProvider>

      <PreviewImage images={selectedImagePreview} isOpen={isOpenImagePreview} onClose={handleClosePreview} initialIndex={0} />

    </Box>
  );
};

const GiveawayFormContainer = () => <BriefGiveawayFormProvider children={<GiveawayForm />} />;

export default GiveawayFormContainer;
